module.exports = __webpack_public_path__ + "img/correct-red.20ee8dd8.svg";